import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver';
import * as _ from 'lodash';
import * as moment from 'moment';
import { environment } from '../../environments/environment';
import { HazardFormListFilterComponent } from '../hazard-form-filter/hazard-form-filter.component';
import { SubmittedFormListFilterComponent } from '../submitted-form-filter/submitted-form-filter.component';
import { IncidentService } from './incidents.service';

@Component({
  selector: 'app-incidents',
  templateUrl: './incidents.component.html',
  styleUrls: ['./incidents.component.scss']
})
export class IncidentsComponent implements OnInit {
  submittedForms: any = [];
  pageNumber: number = 0;
  searchString = '';
  isFromScroll = false;
  isHazardForm: boolean;
  showFilters: boolean;
  filtersViewData = [];
  filtersViewList = [];
  dropdownSettings = {};
  currentPage: string;
  emptyResultError: boolean;
  passwordValue: string = '';
  errMessage: String;
  displayPwd: Boolean;
  downloadType: String;
  inspectionID = '5bd065f36b7e701fb4894bd3';
  selectedFiltersList: undefined;
  public taskObjs = [];
  workOrderId: string;
  constructor(
      private _activatedRoute: ActivatedRoute,
      private _incidentsService: IncidentService,
      private _router: Router,
      private modalService: NgbModal
  ) { }
  checkDisplayFieldValue(data) {
      if (data) {
          return data[this._activatedRoute.snapshot.queryParams['key']]
      }
  };
  displayName() {
      return this._activatedRoute.snapshot.queryParams['display'];
  }
  ngOnInit() {
      this.displayName();
      this.isHazardForm = false

      this._activatedRoute.queryParams.subscribe(queryParams => {
          if (this._activatedRoute.snapshot.queryParams.isHazardForm) {
              this.isHazardForm =
                  this._activatedRoute.snapshot.queryParams.isHazardForm ===
                      'true'
                      ? true
                      : false;
          }
          let queryParamsList = _.cloneDeep(
              this._activatedRoute.snapshot.queryParams
          );
          this.pageNumber = 0;
          this.submittedForms = [];
          if (queryParamsList.filter && queryParamsList.filter === 'true') {
              this.showFilters = true;
              this.dropdownSettings = {
                  singleSelection: false,
                  idField: '_id',
                  textField: 'name',
                  selectAllText: 'Select All',
                  unSelectAllText: 'UnSelect All',
                  // itemsShowLimit: 3,
                  enableCheckAll: false,
                  allowSearchFilter: true,
                  disabled: true
              };
              // this.filtersViewList = [{ _id: 'submitted', name: 'Submitted', data: '&status=submitted' }];
              this.getFilteredTasks(queryParamsList);
              this.previewFiltersListUI(queryParamsList);
          } else {
              this.showFilters = false;
              this.getTasks();
              this.formName();
          }
      });
  }
  formName() {
      return this._activatedRoute.snapshot.queryParams['formName'];
  }
  isAcitve() {
      return this._activatedRoute.snapshot.queryParams['isActive'] ? false : true;
  }
  searchTasks(searchString) {
      this.pageNumber = 0;
      this.submittedForms = [];

      this.isFromScroll = false;
      this.searchString = searchString;

      if (this.searchString.length === 0) {
          // Search string is empty
          this.getTasks();
      } else {
          this.getTasksWithSearchString();
      }
  }

  onScroll() {
      this.isFromScroll = true;
      if (this.searchString.length === 0) {
          // Search string is empty
          this.getTasks();
      } else {
          this.getTasksWithSearchString();
      }
  }
  checkReviewName(status, updatedBy, reviewedBy) {
      let name: string;
      if (reviewedBy && reviewedBy.name) {
          if (status !== 1) {
              name = reviewedBy.name
          }
      } else if (updatedBy && updatedBy.name && status !== 1) {
          name = updatedBy.name;
      } else {
          name = '--';
      }
      return name;
  }

  getTasks() {
      const templateId = this._activatedRoute.snapshot.params['formId'];
      const displayFieldKey = this._activatedRoute.snapshot.queryParams['key'];
      this._incidentsService
          .performPagination(templateId, this.pageNumber, 'incident', displayFieldKey)
          .subscribe((result: any) => {
              console.log(
                  'TCL: SubmittedFormListComponent -> getTasks -> result',
                  result
              );
              if (!this.submittedForms) {
                  this.submittedForms = result.data;
              } else {
                  this.submittedForms = _.union(
                      this.submittedForms,
                      result.data
                  );
              }
              this.pageNumber++;
              if (this.submittedForms.length === 0) {
                  this.emptyResultError = false;
              }
              // console.log('submitted forms');
              // console.log(this.submittedForms);
              _.each(this.submittedForms, function (form) {
                  form.isFormSelected = false;
              });
              var submittedFormIds = {};
              submittedFormIds[templateId] = _.map(this.submittedForms, '_id');
              localStorage.setItem('submittedFormIds', JSON.stringify(submittedFormIds));
              // console.log('submitted forms after checkbox added');
              // console.log(this.submittedForms);
          });
  }
  getFilteredTasks(queryParamsList: any) {
      let dataObj: any = {};
      dataObj.templateId = this._activatedRoute.snapshot.params['formId'];
      dataObj.isHazardForm = queryParamsList.isHazardForm;

      // if (queryParamsList.wid) {
      //     dataObj.workAreasList = queryParamsList.wid;
      // }
      if (queryParamsList.uid) {
          dataObj.usersList = queryParamsList.uid;
      }
      // TODO: Convert status number to int and then send

      if (queryParamsList.status) {
          dataObj.status = queryParamsList.status;
      }

      if (queryParamsList.containsHazards) {
          dataObj.containsHazards = queryParamsList.containsHazards;
      }

      if (queryParamsList.submittedFrom && queryParamsList.submittedTo) {
          dataObj.submittedDateRange = [
              queryParamsList.submittedFrom,
              queryParamsList.submittedTo
          ];
      }

      if (queryParamsList.reviewedFrom && queryParamsList.reviewedTo) {
          dataObj.reviewedDateRange = [
              queryParamsList.reviewedFrom,
              queryParamsList.reviewedTo
          ];
      }

      if (queryParamsList.reportedFrom && queryParamsList.reportedTo) {
          dataObj.reportedDateRange = [
              queryParamsList.reportedFrom,
              queryParamsList.reportedTo
          ];
      }

      if (queryParamsList.FixedFrom && queryParamsList.FixedTo) {
          dataObj.fixedDateRange = [
              queryParamsList.FixedFrom,
              queryParamsList.FixedTo
          ];
      }

      this._incidentsService
          .getFilteredTasks(dataObj, this.pageNumber)
          .subscribe((result: any) => {
              if (!this.submittedForms) {
                  this.submittedForms = result.data;
              } else {
                  this.submittedForms = _.union(
                      this.submittedForms,
                      result.data
                  );
              }
              this.pageNumber++;
              if (this.submittedForms.length === 0) {
                  this.emptyResultError = false;
              }
              _.each(this.submittedForms, function (form) {
                  form.isFormSelected = false;
              });
          });
  }

  previewFiltersListUI(queryParamsList: any) {
      this.filtersViewData = [];
      this.filtersViewList = [];
      if (queryParamsList.wid) {
          queryParamsList.wid = !_.isArray(queryParamsList.wid)
              ? [queryParamsList.wid]
              : queryParamsList.wid;
          _.forEach(queryParamsList.wid, _w => {
              if (queryParamsList[_w]) {
                  this.filtersViewData.push({
                      _id: _w,
                      name: queryParamsList[_w],
                      data:
                          '&wid=' +
                          _w +
                          '&' +
                          _w +
                          '=' +
                          encodeURI(queryParamsList[_w])
                  });
              }
          });
      }

      if (queryParamsList.uid) {
          queryParamsList.uid = !_.isArray(queryParamsList.uid)
              ? [queryParamsList.uid]
              : queryParamsList.uid;
          _.forEach(queryParamsList.uid, _u => {
              if (queryParamsList[_u]) {
                  this.filtersViewData.push({
                      _id: _u,
                      name: queryParamsList[_u],
                      data:
                          '&uid=' +
                          _u +
                          '&' +
                          _u +
                          '=' +
                          encodeURI(queryParamsList[_u])
                  });
              }
          });
      }

      if (queryParamsList.status) {
          queryParamsList.status = !_.isArray(queryParamsList.status)
              ? [queryParamsList.status]
              : queryParamsList.status;
          _.forEach(queryParamsList.status, _status => {
              switch (_status) {
                  case 'submitted':
                      this.filtersViewData.push({
                          _id: 'submitted',
                          name: 'Submitted',
                          data: '&status=submitted'
                      });
                      break;
                  case 'reviewed':
                      this.filtersViewData.push({
                          _id: 'reviewed',
                          name: 'Reviewed',
                          data: '&status=reviewed'
                      });
                      break;
                  case 'active':
                      this.filtersViewData.push({
                          _id: 'active',
                          name: 'Active Hazards',
                          data: '&status=active'
                      });
                      break;
                  case 'fixed':
                      this.filtersViewData.push({
                          _id: 'fixed',
                          name: 'Fixed Hazards',
                          data: '&status=fixed'
                      });
                      break;
                  default:
                      alert('Status not available.');
              }
          });
      }

      if (queryParamsList.containsHazards) {
          if (queryParamsList.containsHazards === 'true') {
              this.filtersViewData.push({
                  _id: 'containsHazards',
                  name: 'Contains Hazards',
                  data: '&containsHazards=true'
              });
          } else if (queryParamsList.containsHazards === 'false') {
              this.filtersViewData.push({
                  _id: 'containsNoHazards',
                  name: 'No Hazards',
                  data: '&containsHazards=false'
              });
          }
      }
      // // SubmittedAt: 21stJul,2018to26thNov,2018
      if (queryParamsList.submittedFrom && queryParamsList.submittedTo) {
          this.filtersViewData.push({
              _id: 'SubmittedAt',
              name: this.getFormattedDateForPreview(
                  'SubmittedAt: ',
                  queryParamsList.submittedFrom,
                  queryParamsList.submittedTo
              ),
              data:
                  '&submittedFrom=' +
                  queryParamsList.submittedFrom +
                  '&submittedTo=' +
                  queryParamsList.submittedTo
          });
      }

      if (queryParamsList.reviewedFrom && queryParamsList.reviewedTo) {
          this.filtersViewData.push({
              _id: 'ReviewedAt',
              name: this.getFormattedDateForPreview(
                  'ReviewedAt: ',
                  queryParamsList.reviewedFrom,
                  queryParamsList.reviewedTo
              ),
              data:
                  '&reviewedFrom=' +
                  queryParamsList.reviewedFrom +
                  '&reviewedTo=' +
                  queryParamsList.reviewedTo
          });
      }

      if (queryParamsList.reportedFrom && queryParamsList.reportedTo) {
          this.filtersViewData.push({
              _id: 'ReportedAt',
              name: this.getFormattedDateForPreview(
                  'ReportedAt: ',
                  queryParamsList.reportedFrom,
                  queryParamsList.reportedTo
              ),
              data:
                  '&reportedFrom=' +
                  queryParamsList.reportedFrom +
                  '&reportedTo=' +
                  queryParamsList.reportedTo
          });
      }

      if (queryParamsList.FixedFrom && queryParamsList.FixedTo) {
          this.filtersViewData.push({
              _id: 'FixedAt',
              name: this.getFormattedDateForPreview(
                  'FixedAt: ',
                  queryParamsList.FixedFrom,
                  queryParamsList.FixedTo
              ),
              data:
                  '&FixedFrom=' +
                  queryParamsList.FixedFrom +
                  '&FixedTo=' +
                  queryParamsList.FixedTo
          });
      }

      /* Now that all the view data has been created, this will be used later to call the API
      whenever a change to the filters has been made. */

      // Creating filtersViewList for populating the UI
      _.forEach(this.filtersViewData, data => {
          this.filtersViewList.push(_.pick(data, ['_id', 'name']));
      });
  }

  getFormattedDateForPreview(title, fromDate, toDate) {
      return (
          title +
          moment(fromDate).format('MMM Do, YYYY') +
          ' to ' +
          moment(toDate).format('MMM Do, YYYY')
      );
  }

  onDeSelect(items: any) {
      let innerFiltersViewData = _.cloneDeep(this.filtersViewData);
      _.forEach(this.filtersViewData, function (n) {
          switch (items._id) {
              case 'submitted':
                  _.remove(innerFiltersViewData, (m: any) => {
                      return m._id === 'SubmittedAt' || m._id === 'submitted';
                  });
                  break;
              case 'reviewed':
                  _.remove(innerFiltersViewData, (m: any) => {
                      return m._id === 'ReviewedAt' || m._id === 'reviewed';
                  });
                  break;
              case 'active':
                  _.remove(innerFiltersViewData, (m: any) => {
                      return m._id === 'ReportedAt' || m._id === 'active';
                  });
                  break;
              case 'fixed':
                  _.remove(innerFiltersViewData, (m: any) => {
                      return m._id === 'FixedAt' || m._id === 'fixed';
                  });
                  break;
              default:
                  _.remove(innerFiltersViewData, (m: any) => {
                      return m._id === items._id;
                  });
          }
      });
      this.filtersViewData = innerFiltersViewData;

      let queryParams = this._activatedRoute.snapshot.queryParams;
      let newUrl = '';
      if (!_.isEmpty(this.filtersViewData)) {
          if (
              queryParams.isHazardForm &&
              queryParams.isHazardForm === 'true'
          ) {
              newUrl =
                  '/hazards/' +
                  this._activatedRoute.snapshot.params['formId'] +
                  '?isHazardForm=true&filter=true';
          } else {
              if (queryParams.display) {
                  newUrl = this.queryparamsUrl(queryParams) + '&filter=true';
              } else {
                  newUrl = '/submittedFormList/' + this._activatedRoute.snapshot.params['formId'] + '?filter=true';
              }
          }
          _.forEach(this.filtersViewData, item => {
              newUrl = newUrl.concat(item.data);
          });
          console.log('if data is there', newUrl)
      } else {
          if (queryParams.isHazardForm && queryParams.isHazardForm === 'true') {
              newUrl =
                  '/hazards/' +
                  this._activatedRoute.snapshot.params['formId'] +
                  '?isHazardForm=true&filter=false';
          } else {
              if (queryParams.display) {
                  newUrl = this.queryparamsUrl(queryParams) + '&filter=' + false;
              } else {
                  newUrl = '/submittedFormList/' + this._activatedRoute.snapshot.params['formId'] + '?filter=false';
              }
          }
          console.log('if data is not there', newUrl)
      }
      this._router.navigateByUrl(newUrl);
  }
  queryparamsUrl(queryParams) {
      return '/submittedFormList/' + this._activatedRoute.snapshot.params['formId'] + '?formName=' + queryParams.formName + '&key=' + queryParams.key + '&display=' + queryParams.display;
  }
  clearFilters() {
      let queryParams = this._activatedRoute.snapshot.queryParams;
      let newUrl = '';
      if (queryParams.isHazardForm && queryParams.isHazardForm === 'true') {
          newUrl = '/hazards/' + this._activatedRoute.snapshot.params['formId'];
      } else {
          if (queryParams.display) {
              newUrl = this.queryparamsUrl(queryParams);
          } else {
              newUrl = '/submittedFormList/' + this._activatedRoute.snapshot.params['formId'];
          }
      }
      this._router.navigateByUrl(newUrl);
  }

  getTasksWithSearchString() {
      const templateId = this._activatedRoute.snapshot.params['formId'];
      // Search tasks using search string
      this._incidentsService
          .getTasksOnSearch(
              this.searchString,
              templateId,
              this.pageNumber,
              this.isHazardForm
          )
          .subscribe(
              (result: any) => {
                  if (this.isFromScroll) {
                      this.submittedForms = _.union(
                          this.submittedForms,
                          result.data
                      );
                  } else {
                      this.submittedForms = result.data;
                  }
                  this.pageNumber++;
              },
              err => {
                  // console.log('Search tasks Error :  ', err)
              }
          );
      if (this.submittedForms.length === 0) {
          this.emptyResultError = true;
      }
  }

  downloadmultiplecsv() {
      let csvIds = [];
      _.forEach(this.taskObjs, task => {
          csvIds.push(task._id);
      });
      // console.log(csvIds, 'ids for csv');
      let dataObj = {
          ids: csvIds,
          downloadType: 'CSV'
      };

      const templateId = this._activatedRoute.snapshot.params['formId'];
      if (templateId === '5da944a49e6002772ba9bbcc') {
          this._incidentsService
              .downloadLHoistCSV(dataObj)
              .subscribe((data: any) => {
                  let folderName = '';
                  folderName = (environment.APP_NAME || '') + ' CSV ' + moment(Date.now()).format('MM-DD-YYYY hh.mm A');
                  const blob = new Blob([data], {
                      type: 'application/xlsx'//'application/zip;charset=utf-8'
                  });
                  saveAs(blob, `${folderName}.xlsx`);
              });
          return;
      }

      this._incidentsService
          .downloadMultipleCSV(dataObj)
          .subscribe((data: any) => {
              let folderName = '';
              folderName = (environment.APP_NAME || '') + ' CSV ' + moment(Date.now()).format('MM-DD-YYYY hh.mm A');
              const blob = new Blob([data], {
                  type: 'application/zip;charset=utf-8'
              });
              saveAs(blob, `${folderName}.zip`);
          });
  }
  toggleModal(_downloadType: String) {
      this.downloadType = _downloadType;
  }
  closeDownloadErrorModal() {
      // $('#downloadErrorModal').modal('toggle');
  }
  downloadmultiplenewpdf() {
      if (this.taskObjs.length > 5) {
          this.closeDownloadErrorModal();
          return;
      }
      let dataObj = [];
      _.forEach(this.taskObjs, task => {
          if (this.isHazardForm) {
              let obj = {
                  _id: task._id,
                  taskId: task.taskId,
                  downloadType: this.downloadType,
                  workOrderId: task.workOrderId,
                  inspectionId: task.inspectionId,
              };
              dataObj.push(obj);
          } else {
              let obj = {
                  _id: task._id,
                  taskId: task.taskId,
                  downloadType: this.downloadType,
                  workOrderId: task.workOrderId,
                  inspectionId: task.inspectionID,
              };
              dataObj.push(obj);
          }
      });
      this._incidentsService
          .downloadMultiplePdf(dataObj)
          .subscribe((data: any) => {
              let folderName = '';
              folderName =
                  (environment.APP_NAME || '') +
                  ' PDF ' +
                  moment(Date.now()).format('MM-DD-YYYY hh.mm A');
              const blob = new Blob([data], {
                  type: 'application/zip;charset=utf-8'
              });
              saveAs(blob, `${folderName}.zip`);
          });
  }

  checkBoxClick(task, event) {

      if (event.target.checked === true) {
          const index = this.taskObjs.indexOf(task);
          if (index === -1) {
              this.taskObjs.push(task);
          }
      } else {
          const index = this.taskObjs.indexOf(task);

          if (index !== -1) {
              this.taskObjs.splice(index, 1);
          }

      }
      // console.log(this.taskObjs.length);
      if (this.taskObjs.length < this.submittedForms.length) {
          // $('#checkbox-style-div-2').prop('checked', false);
      } else {
          // $('#checkbox-style-div-2').prop('checked', true);
      }

      event.stopPropagation();


  }
  fixHazardform(taskId) {
      this._router.navigateByUrl(
          '/hazardform/' + taskId + '?currentPage=hazards'
      );
  }

  navigateToPreview(taskId, event, isHazardForm, form) {
      // if (event.path[0].localName !== 'label') {
      // }
      if (isHazardForm) {
          this._router.navigateByUrl(
              '/submittedFormPreview/' + taskId + '?currentPage=hazards'
          );
      } else {
          let queryPararms = '?currentPage=incidentForms';
          // Assuming the RCA and Resolve forms contains inspectionId as the incident form taskId. 
          if(form && !form.inspectionId) {
            // To identify the form type as incident and not RCA or Resolve
            queryPararms += '&formType=incident';
          }
          this._router.navigateByUrl('/submittedFormPreview/' + taskId + queryPararms);
      }
  }
  navigateInspection() {
      this._router.navigateByUrl('/formFilling/' + this._activatedRoute.snapshot.params['formId'] + '?currentPage=incidentForms');
  }

  getIncidentButtonLabel(): string {
      const formId = this._activatedRoute.snapshot.params['formId'];
      if (formId === 'fh_task_template:incidentform') {
          return 'Report an Incident';
      } else if (formId === 'fh_task_template:resolveform') {
          return 'Resolve Incident';
      } else if (formId === 'fh_task_template:rootcauseform') {
          return 'Submit RCA';
      }
      return 'Report an Incident';
  }

  navigateToHazardForm() {
      this._router.navigateByUrl('/formFilling/' + this._activatedRoute.snapshot.params['formId'] + '?currentPage=hazards' + '?isHazardForm=' + this.isHazardForm);
  }

  selectAllForms(event) {
      let context = this;
      if (event.target.checked === true) {
          _.each(this.submittedForms, function (form: any) {
              form.isFormSelected = true;
              // console.log(form._id);
              const index = context.taskObjs.indexOf(form);
              if (index === -1) {
                  context.taskObjs.push(form);
              }
          });
      } else {
          _.each(this.submittedForms, function (form: any) {
              form.isFormSelected = false;
              const index = context.taskObjs.indexOf(form);

              if (index !== -1) {
                  context.taskObjs.splice(index, 1);
              }
          });
      }

      if (this.taskObjs.length < this.submittedForms.length) {
          // $('#checkbox-style-div-2').prop('checked', false);
      } else {
          // $('#checkbox-style-div-2').prop('checked', true);
      }
      console.log(context.taskObjs.length);
  }

  submittedformsfilter() {
      let modalOptions: any = {
          size: 'md',
          centered: true,
          windowClass: 'inspection-filter'
      };

      let dataObj: any = {};
      let queryParams = _.cloneDeep(
          this._activatedRoute.snapshot.queryParams
      );

      // if (queryParams.wid) {
      //     dataObj.wid = [];
      //     queryParams.wid = !_.isArray(queryParams.wid)
      //         ? [queryParams.wid]
      //         : queryParams.wid;
      //     _.forEach(queryParams.wid, _workAreaId => {
      //         if (queryParams[_workAreaId]) {
      //             dataObj.wid.push({
      //                 _id: _workAreaId,
      //                 name: queryParams[_workAreaId]
      //             });
      //         }
      //     });
      //     queryParams.wid = dataObj.wid;
      // }

      if (queryParams.uid) {
          dataObj.uid = [];
          queryParams.uid = !_.isArray(queryParams.uid)
              ? [queryParams.uid]
              : queryParams.uid;
          _.forEach(queryParams.uid, _userId => {
              if (queryParams[_userId]) {
                  dataObj.uid.push({
                      _id: _userId,
                      name: queryParams[_userId]
                  });
              }
          });
          queryParams.uid = dataObj.uid;
      }

      if (queryParams.status) {
          dataObj.status = [];
          queryParams.status = !_.isArray(queryParams.status)
              ? [queryParams.status]
              : queryParams.status;
          if (_.includes(queryParams.status, 'submitted')) {
              dataObj.status.push({ _id: 'submitted', name: 'Submitted' });
          }
          if (_.includes(queryParams.status, 'reviewed')) {
              dataObj.status.push({ _id: 'reviewed', name: 'Reviewed' });
          }
          queryParams.status = dataObj.status;
      }

      const modalRef = this.modalService.open(
          SubmittedFormListFilterComponent,
          modalOptions
      );
      modalRef.componentInstance.parentComponentData = {
          templateId: this._activatedRoute.snapshot.params['formId'],
          queryParams: queryParams
      };
      modalRef.result.then(
          res => {
              console.log('confirmed for changes');
          },
          () => {
              console.log('not confirmed for changes');
          }
      );
  }

  hazardfilter() {
      let modalOptions: any = {
          size: 'md',
          centered: true,
          windowClass: 'hazard-filter'
      };

      let dataObj: any = {};
      let queryParams = _.cloneDeep(
          this._activatedRoute.snapshot.queryParams
      );

      // if (queryParams.wid) {
      //     dataObj.wid = [];
      //     queryParams.wid = !_.isArray(queryParams.wid)
      //         ? [queryParams.wid]
      //         : queryParams.wid;
      //     _.forEach(queryParams.wid, _workAreaId => {
      //         if (queryParams[_workAreaId]) {
      //             dataObj.wid.push({
      //                 _id: _workAreaId,
      //                 name: queryParams[_workAreaId]
      //             });
      //         }
      //     });
      //     queryParams.wid = dataObj.wid;
      // }

      if (queryParams.status) {
          dataObj.status = [];
          queryParams.status = !_.isArray(queryParams.status)
              ? [queryParams.status]
              : queryParams.status;
          if (_.includes(queryParams.status, 'active')) {
              dataObj.status.push({ _id: 'active', name: 'Active Hazards' });
          }
          if (_.includes(queryParams.status, 'fixed')) {
              dataObj.status.push({ _id: 'fixed', name: 'Fixed Hazards' });
          }
          queryParams.status = dataObj.status;
      }
      const modalRef = this.modalService.open(
          HazardFormListFilterComponent,
          modalOptions
      );
      modalRef.componentInstance.parentComponentData = {
          templateId: this._activatedRoute.snapshot.params['formId'],
          queryParams: queryParams
      };
      modalRef.result.then(
          res => {
              console.log('confirmed for changes');
          },
          () => {
              console.log('not confirmed for changes');
          }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/incidents/incidents.component.ts